<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img alt="" src="images/xsm_jianzaoye.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>太保制造行业1-6类雇主险（限广东企业）</h2>
					<div>行业首选方案 | 中国太平洋产险承保 | 不限厂商品牌</div>

					<p>
						① 保额更高，保费更便宜
						<br />
						② 误工费无免赔，100元/人/天，每次90天，累计180天
						<br />
						③ 医疗费0免赔，医保范围内100%赔付
						<br />
						④ 扩展24小时个人意外
						<br />
					</p>

					<!--          <div style="margin: 15px 0">-->
					<!--                        <i class="el-icon-success" style="color: #409EFF;font-size: 18px"></i> 灵活投保，可选1-3月方案，适用临时用工<br>-->
					<!--                        <i class="el-icon-success" style="color: #409EFF;font-size: 18px"></i> 人性关怀，扩展24小时意外，非工作意外也保障<br>-->
					<!--                        <i class="el-icon-success" style="color: #409EFF;font-size: 18px"></i> 保障充足，100/120万方案可选，保障覆盖全面<br>-->
					<!--            <i class="el-icon-error" style="color: red;font-size: 18px"></i>-->
					<!--            <span style="color: red"> 存在安全带免赔特约</span><br>-->
					<!--            <i class="el-icon-error" style="color: red;font-size: 18px"></i>-->
					<!--            <span style="color: red"> 不含第三者赔偿责任</span><br>-->
					<!--            <i class="el-icon-error" style="color: red;font-size: 18px"></i>-->
					<!--            <span style="color: red"> 不支持人员批增和替换</span>-->
					<!--          </div>-->
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud
						ref="crud"
						:cell-style="onCellStyle"
						:data="dataPlan"
						:option="optionPlan"
						:span-method="spanMethodPlan"></avue-crud>
				</el-card>
				<el-card header="赔付标准">
					<!--          <el-row justify="center" type="flex">-->
					<!--            <div style="display: flex;flex-direction: column;margin-bottom: 20px">-->
					<!--              <span class="red-bold">社保用药100%赔付</span>-->
					<!--            </div>-->
					<!--          </el-row>-->
					<avue-crud ref="crud" :data="dataBenefit" :option="optionBenefit">
						<template slot="header"></template>
					</avue-crud>
				</el-card>
				<!--        <el-descriptions :column="1" border title="注意事项">-->
				<!--          <el-descriptions-item label="投保年龄">-->
				<!--            投保年龄限16-65周岁-->
				<!--          </el-descriptions-item>-->
				<!--          <el-descriptions-item label="可投保职业">-->
				<!--            本保单被保险人雇员为电梯/商业中央空调安装、运营、维护等（不含制造）相关人员-->
				<!--          </el-descriptions-item>-->
				<!--        </el-descriptions>-->
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="{question = '', answer = ''} in dataQA" :key="question">
								<div>
									<span
										style="
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ question }}</span>
								</div>
								<div style="display: flex; margin-top: 12px">
									<span
										style="
											width: 20px;
											height: 28px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>

									<div v-if="question === '中途是否可以加人？新增人员如何收费？'" style="display: inline-block">
										中途可以增加保障人员。保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。
										<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
											<tr style="text-align: center">
												<th>批增收费比例</th>
												<th v-for="item in 12">{{ item }}个月</th>
											</tr>
											<tr style="text-align: center">
												<td>1-3类</td>
												<td v-for="item in questionDataRate">{{ item }}</td>
											</tr>
											<tr style="text-align: center">
												<td>4-5类</td>
												<td v-for="item in questionDataRate">{{ item }}</td>
											</tr>
											<tr style="text-align: center">
												<td>6类</td>
												<td v-for="item in questionDataRate">{{ item }}</td>
											</tr>
										</table>
									</div>

									<span v-else style="white-space: pre-wrap">{{ answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<div style="line-height: 26px; white-space: pre-line">
							<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
							<div style="line-height: 32px; white-space: pre-line">
								1、本保险适用以下保险条款： 2、本保险由中国太平洋财产保险股份有限公司承保，
								<span class="red-bold">仅限承保营业执照注册地址在广东的企业和组织</span>
								。
								3、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
								4、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；
								<span class="red-bold">
									故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；
								</span>
								因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
								5、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
								6、本保险根据投保单位的需求提供电子发票或纸质专票。 7、本保险由博维保险经纪有限公司面向
								<span class="red-bold">广东省内销售并提供服务</span>
								，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。 8、
								<span class="red-bold">
									鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。在保单生效后申请退保或批减在保人员的，可退保费为0。
								</span>
								9、中途可以增加保障人员。
								<span class="red-bold">
									保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。
								</span>

								<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
									<tr style="text-align: center">
										<th>批增收费比例</th>
										<th v-for="item in 12">{{ item }}个月</th>
									</tr>
									<tr style="text-align: center">
										<td>1-3类</td>
										<td v-for="item in questionDataRate">{{ item }}</td>
									</tr>
									<tr style="text-align: center">
										<td>4-5类</td>
										<td v-for="item in questionDataRate">{{ item }}</td>
									</tr>
									<tr style="text-align: center">
										<td>6类</td>
										<td v-for="item in questionDataRate">{{ item }}</td>
									</tr>
								</table>
								10、
								<span class="red-bold">
									本保单不承保职业：船舶制造人员
									、玻璃、陶瓷、搪瓷制造业人员、涉及爆破的相关工作人员，如作业内容含有保险人不承保的职业类别，保险人不承担任何赔偿责任。
								</span>
							</div>
							<el-divider></el-divider>
							<h3>特别约定</h3>
							<div>
								<h4>1、保障期限：</h4>
								自所投保雇主责任保险生效日起，保险期限为一年。
								<h4>2、特别特约：</h4>
								（1）被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人
								<span class="red-bold">超过72小时才报案</span>
								，则保险人对按保单约定的应承担的保险责任，
								<span class="red-bold">免赔50%</span>
								。如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
								（2）被保险人从业人员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。
								（3）鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。
								<span class="red-bold">在保单生效后申请退保或批减在保人员的，可退保费为0。</span>
								（4）本保单仅承保制造相关行业。 （5）被保险人从业人员遭受伤害时，
								<span class="red-bold">
									实际从事的工作危险程度高于投保人明确告知保险人的工作类型的，则保险人根据实际从事工作职业类别与保单约定职业类别的级差，按每一个级差扣减保额20%免赔（比如实际6类投保4类，需扣减40%免赔，以此类推）。如实际工作属于拒绝承保职业，保险人不承担任何赔偿责任。
								</span>
								（6）在工作时间和工作岗位，
								<span class="red-bold">
									突发疾病死亡或者在48小时之内经抢救无效死亡（从业人员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔款=每人身故赔偿限额*20%。
								</span>
								（7）医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准100%赔付。
								（8）误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。
								<span class="red-bold">被保险人从业人员仅接受门诊治疗的，按本保单约定无误工费赔付。</span>
								（9）
								<span class="red-bold">
									被保险人从业人员从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证）
								</span>
								，否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，
								<span class="red-bold">免赔25%。</span>
								（10）
								<span class="red-bold">本保单指定就诊医院为大陆境内二级及以上公立医院。</span>
								如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。
								（11）兹经双方协商同意，鉴于投保人已支付相应保费，保险人扩展承保被保险人雇员在24小时内因意外事故到医院治疗被保险人依法应承担的经济赔偿责任，
								<span class="red-bold">
									24小时意外事故医疗责任与雇主工伤医疗责任共用限额，最高不超过保单列明的工伤医疗责任限额。
								</span>
								24小时意外事故医疗责任
								<span class="red-bold">
									不负责赔偿误工费、住院伙食费、生活护理费、转院就医食宿交通费、残疾辅助器具费用等其他费用。
								</span>
								（12）本保单伤残赔偿金：按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级而支付相应赔偿金。相应的赔偿限额为该伤残等级所对应的下列“伤残等级赔偿限额比例表”的比例乘以每人死亡赔偿限额所得金额。本保单适用伤残赔付比例按：一级伤残 100％，二级伤残 80％，三级伤残 70％，四级伤残60％，五级伤残50％，六级伤残40％，七级伤残30％，
								<span class="red-bold">八级伤残20％，九级伤残10％，十级伤残 5％。</span>
								（13）本保单附加24小时个人意外事故条款，扩展承保被保险人的雇员在24小时内遭受意外事故造成的永久性伤残和死亡。其中，伤残评定标准参照《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）评定，评定级别后赔偿金额计算标准同主险赔偿标准并以保单约定的伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。
								<span class="red-bold">
									24小时个人意外事故死亡伤残责任与雇主工伤死亡伤残责任共用限额，每人最高不超过保单列明的雇主工伤死亡伤残责任限额的50%。对由于被保险人直接承担的因为被保险人的雇员从事的下列活动引起的责任，本保险不负责赔偿:打猎、登山、任何形式的竞赛、滑雪、酗酒、服用药物或狂欢。
								</span>
								（14）本保单承保法律费用责任，
								<span class="red-bold">累计赔偿限额为RMB10万元</span>
								，每次事故赔偿限额为RMB10万元。 （15）太平洋产险全国统一客户投诉电话：95500语音提示或按#号键-3-2-4。
								<h4>3、责任免除：</h4>
								<span style="font-weight: bold">
									第一条 由于下列原因造成的任何损失、费用或赔偿责任，保险人不负责赔偿：
									（一）投保人、被保险人或其法人、代理人的违法行为、犯罪行为、故意行为或重大过失行为；
									（二）战争、敌对行动、军事行动、武装冲突、罢工、暴动、民众骚乱、恐怖活动；
									（三）核辐射、核爆炸、核污染，或其他放射性、有毒、易爆物质的污染或影响； （四）行政行为、司法行为；
									（五）接触、使用石棉（包括石棉制品、石棉纤维等含有石棉成份的物质）或硅（包括硅产品、硅石粉尘等以任何形态存在的硅）；
									（六）传染病、分娩、流产、保单已承保的职业病以外的其他疾病（包括免疫系统疾病及精神疾病），以及因前述原因而接受医疗、诊疗，但主条款第五条第（七）款不受此限。
									第二条 保险事故发生时，被保险人的雇员存在下列情形之一，并因此导致人身损害的，保险人不承担赔偿责任：
									（一）自杀、自残、打架、斗殴、受酒精或毒品的影响； （二）故意行为、违法行为、犯罪行为；
									（三）进行下列高风险运动、活动：
									1．从事潜水、登山、滑水、滑雪、滑冰、滑板、滑翔、跳伞、攀岩、蹦极或其他类似的极限运动；
									2．进行探险活动； 3．进行摔跤、柔道、空手道、跆拳道、拳击或其他类似的搏击运动；
									4．进行需要经过特别训练的特技表演； 5．参与任何职业、半职业或专业的体育运动；
									6．进行赛马、各种车辆表演、车辆竞赛或练习、驾驶卡丁车等高风险运动。
									（四）未遵医嘱，私自过量或不足量服用、涂用、注射药物或进行任何非治疗工伤所必须的手术；
									（五）无驾驶证，驾驶证失效或者被依法扣留、暂扣、吊销期间驾驶机动车，驾驶与驾驶证载明的准驾车型不相符合的机动车；
									（六）无国家有关部门核发的有效操作资格证而使用各种专用机械、特种设备或特种车辆或类似设备装置的。
									第三条 下列损失、费用和责任，保险人不承担赔偿责任： （一）被保险人对本合同生效前已发生事故的赔偿责任；
									（二）除本合同列明负责赔偿的项目外，其他超出被保险人职员所在地工伤保险和基本医疗保险诊疗项目目录、药品目录、医疗服务设施范围和支付标准的医疗费用；
									（三）精神损害赔偿及任何性质的罚款、罚金、惩罚性赔偿；
									（四）被保险人因合同或协议（含劳动合同、用工协议等）的约定而应承担的赔偿责任，但无该合同或协议的存在被保险人依法仍应承担的赔偿责任不受此限；
									（五）被保险人的任何间接损失； （六）被保险人应自行承担的免赔额。 第四条
									其他不属于本保险责任范围内的损失、费用和责任，保险人不负责赔偿。
								</span>
							</div>
						</div>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {
	optionBenefit,
	optionPlanXsmJianZao,
	optionPremium,
	optionShortPeriodRate,
} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product7Details',
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionPlanXsmJianZao,
			optionPremium: optionPremium,
			optionBenefit: optionBenefit,
			optionShortPeriodRate: optionShortPeriodRate,
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '30万/人',
					plan2: '50万/人',
					plan3: '80万/人',
					plan4: '100万/人',
					plan5: '120万/人',
				},
				{
					insuredItem: '医疗费用',
					plan1: '3万/人',
					plan2: '5万/人',
					plan3: '8万/人',
					plan4: '10万/人',
					plan5: '20万/人',
				},
				{
					insuredItem: '误工费用',
					plan1: '100元/天（每次90天，累计180天为限）',
				},
				{
					insuredItem: '法律费用',
					plan1: '10万/企业',
				},
				{
					insuredItem: '医疗费用赔付',
					plan1: '社保用药100%赔付',
				},
				{
					insuredItem: '24小时个人意外',
					plan1: '扩展承保被保险人的雇员在24小时内遭受意外事故造成的死亡、永久性伤残和医疗费赔偿。',
				},
				{
					insuredItem: '1-3类',
					plan1: '250元/人/年',
					plan2: '430元/人/年',
					plan3: '620元/人/年',
					plan4: '810元/人/年',
					plan5: '1250元/人/年',
				},
				{
					insuredItem: '4-5类',
					plan1: '540元/人/年',
					plan2: '900元/人/年',
					plan3: '1380元/人/年',
					plan4: '1750元/人/年',
					plan5: '2250元/人/年',
				},
				{
					insuredItem: '6类',
					plan1: '880元/人/年',
					plan2: '1250元/人/年',
					plan3: '2000元/人/年',
					plan4: '2250元/人/年',
					plan5: '2680元/人/年',
				},
				{
					insuredItem: '附加条款',
					plan1: `24小时个人意外事故条款<br>24小时个人意外事故医疗费用条款<br>附加伤残赔偿金赔偿限额比例调整条款`,
				},
			],
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '5%',
					level9: '10%',
					level8: '20%',
					level7: '30%',
					level6: '40%',
					level5: '50%',
					level4: '60%',
					level3: '70%',
					level2: '80%',
					level1: '100%',
				},
			],
			questionDataRate: ['10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '85%', '90%', '95%', '100%'],
			dataQA: [
				{
					question: '本产品的保险公司是哪家？',
					answer: '本产品由世界500强的中国太平洋财产保险股份有限公司承保。',
				},
				{
					question: '广东新市民保（制造行业）的保险责任是什么？',
					answer:
						'在在保险期间内，被保险人的雇员在中华人民共和国境内因下列情形导致伤残或死亡，依照中华人民共和国法律（不含香港、澳门特别行政区和台湾地区法律，下同）应由被保险人承担的经济赔偿责任，保险人按照本合同约定负责赔偿：\n' +
						'（一）在工作时间和工作场所内，因工作原因受到事故伤害的；\n' +
						'（二）工作时间前后在工作场所内，从事与工作有关的预备性或者收尾性工作受到事故伤害的；\n' +
						'（三）在工作时间和工作场所内，因履行工作职责受到暴力等意外伤害的；\n' +
						'（四）被诊断、鉴定为在被保险人处工作期间患职业病的；\n' +
						'（五）因工外出期间，由于工作原因受到伤害或者发生事故下落不明的；\n' +
						'（六）在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的；\n' +
						'（七）在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡的；\n' +
						'（八）在抢险救灾等维护国家利益、公共利益活动中受到伤害的；\n' +
						'（九）雇员原在军队服役，因战、因公负伤致残，已取得革命伤残军人证，到用人单位后旧伤复发的；\n' +
						'（十）法律、行政法规规定应当认定为工伤的其他情形。\n' +
						'保险事故发生后，被保险人因保险事故而被提起仲裁或者诉讼的，对应由被保险人支付的仲裁或诉讼费用以及事先经保险人书面同意支付的其他必要的、合理的费用（以下简称“法律费用”），保险人按照本合同约定也负责赔偿。',
				},
				{
					question: '哪些职业可保？',
					answer:
						'本保单仅承保制造相关行业。本产品可保障职业：铣、刨工；铸、锻造工；金属热处理工、建筑五金制品制作工、日用五金制品制作工；光纤光缆制造工、电线电缆制造工、绝缘制品制造工；橡胶制品生产工、人造板制胶工、纸箱纸盒制作工；纺织、成衣、鞋帽、皮革业工人；制米工、制粉工、制油工、冷冻食品制作工、饲料加工工等。需根据实际工作职业选择对应类别。',
				},
				{
					question: '中途是否可以加人？新增人员如何收费？',
					answer: '中途可以增加保障人员。保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。',
				},
				{
					question: '如果从事高处作业，但是无安全带或者无特种作业操作证（比如高处作业证），保险公司是否拒赔？',
					answer:
						'不会拒赔。被保险人从业人员从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，免赔25%。',
				},
				{
					question: '什么是高处作业？',
					answer:
						'国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。”',
				},
				{
					question: '误工费怎么赔？',
					answer:
						'按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。被保险人雇员仅接受门诊治疗的，按本保单约定无误工费赔付。',
				},
				{
					question: '怎么投保？怎么支付？',
					answer:
						'直接用电脑在此网页上操作即可，无需任何纸质资料，具体流程：选方案→填信息→支付保费→获取保单。目前支持微信、支付宝、银联支付。',
				},
				{
					question: '保单和发票怎么获取？',
					answer: '线上投保完成后实时出具电子保单，如果客户选择普票则实时出具电子普票，如果选择专票则通过快递寄送。',
				},
				{
					question: '保单如何查验真伪？',
					answer: '可以通过拨打太平洋保险全国客服电话95500进行人工查询。',
				},
				{
					question: '中途是否可以换人？',
					answer:
						'在保险有效期内，被替换的员工无出险的前提下，可以替换，无需缴纳保费。替换时，原1-3类职业人员只能替换为新的1-3类职业人员，原4-5类职业人员只能替换为新的4-5类职业人员。不分节假日，全天24小时，均可线上直接替换或新增人员。',
				},
				{
					question: '出险从业人员是否可替换出去？',
					answer: '不可以。',
				},
				{
					question: '怎么理赔？多久收到赔款？',
					answer:
						'出险后请拨打理赔专线400-180-1616报案→收集资料→提交审核→支付结案。万元以下案件资料齐全三个工作日赔款到账；万元以上案件纸质资料齐全，一般七个工作日赔款到账。',
				},
			],
		}
	},
	methods: {
		handleInsure() {
			this.$emit('insure')
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 2 || rowIndex === 3 || rowIndex === 4 || rowIndex === 5 || rowIndex === 9) {
				if (columnIndex === 1) {
					return [1, 4]
				}
			}
			// if (rowIndex === 4) {
			//   if (columnIndex === 0) {
			//     return [1, 3]
			//   }
			// }
		},
		onCellStyle({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 6 || rowIndex === 7 || rowIndex === 8) {
				if (columnIndex !== 0) {
					return {
						color: 'red',
						fontWeight: 'bold',
						fontSize: '16px',
					}
				}
			} else if (rowIndex === 4) {
				return {
					background: '#fafafa',
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}
</style>
